module.exports = __webpack_public_path__ + "static/clj-17afc4ce6d4f9d1b68a7dfd021f559f5.png";